import React, {useContext, useEffect, useState} from 'react';

import AdditionalPages from './AdditionalPages';
import {WebContext} from '../../Utility';

export default () => {
  const {memberProfile = {}} = useContext(WebContext) || {};
  let {
     about_us = '', about_us_images=[]
  } = memberProfile;

  const [imageArr, setImageArr] = useState([]);

  useEffect(() => {
    if(!about_us_images || about_us_images && about_us_images.length == 0 ) return
    let tempArr = [];
    if(about_us_images && about_us_images.length>0) {
      about_us_images.forEach(item => {
        if(item.is_active && item.image_url!=null) tempArr.push(item.image_url);
      })
    } else {
      tempArr = ['https://app.travclan.com/media/appcms/About_Us_Page.jpg']
    }
    setImageArr(tempArr);
  },[about_us_images])

  const pageData = {
    title: 'ABOUT US',
    text: about_us,
  }

  return <AdditionalPages pageData={pageData} imageArr={imageArr} />
}
